import { withAuth } from '@bounty/creators-common/components/RequireAuth'
import { withReadyRouter } from '../../../withReadyRouter'
import { NextPageWithLayout } from '../../_app'
import { ReactElement } from 'react'
import { withSEO } from '../../../withSEO'
import { Layout } from '../../../Layout'
import { BountyDetailScreen } from '@bounty/creators-common/screens/bounty-detail/bounty-detail/BountiesDetail'

const Page: NextPageWithLayout = withAuth(
  withReadyRouter(withSEO(BountyDetailScreen)),
)

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export default Page
